import { PagedDialog, Button, Tooltip } from '@components';
import { BUTTON_TYPES, TOOLTIP_POSITION } from '@types';
import styles from './EditShipment.module.scss';

type TProps = {
	toggleOpen: (b: boolean) => void;
	saveShipment: () => void;
	loading: boolean;
	disableSave: boolean;
	saveReason?: string;
}

export const Footer = (props: TProps) => {
	const { toggleOpen, saveShipment, loading, disableSave, saveReason } = props;
	const saveButton = (
		<Button
			text={'Save Changes'}
			onClick={saveShipment}
			loading={loading}
			disabled={disableSave}
		/>
	);
	return (
		<PagedDialog.Footer>
			<div className={styles.footerContainer}>
				<Button
					text={'Cancel'}
					onClick={() => toggleOpen(false)}
					type={BUTTON_TYPES.TERTIARY}
				/>
				{disableSave && saveReason
					? <Tooltip position={TOOLTIP_POSITION.TOP} text={saveReason}>{saveButton}</Tooltip>
					: saveButton}
			</div>
		</PagedDialog.Footer>
	);
}
Footer.displayName = 'Footer';
